module.exports = __webpack_public_path__ + "img/mon_rotated.144fa446.png";